import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";

import { inputDefaultColor, loadingShimmer } from "../styles/color";

const LoadingTile = (props) => {
  const loadingStyles = css`
    background: linear-gradient(
      115deg,
      ${props.bgColor} 20%,
      ${props.fgColor} 30%,
      ${props.bgColor} 40%
    );
    background-size: 500% 500%;
    aspect-ratio: ${props.aspectRatio};
    border-radius: 0.5rem;

    animation: LoadingShimmer 1.7s ease infinite;

    @keyframes LoadingShimmer {
      0% {
        background-position: 50% 0%;
      }
      100% {
        background-position: -50% 0%;
      }
    }
  `;

  return <div css={loadingStyles}></div>;
};

LoadingTile.defaultProps = {
  aspectRatio: "3 / 1",
  bgColor: inputDefaultColor,
  fgColor: loadingShimmer,
};

LoadingTile.propTypes = {
  aspectRatio: PropTypes.string,
  bgColor: PropTypes.string,
  fgColor: PropTypes.string,
};

export default LoadingTile;
